import { action, makeObservable } from 'mobx';

import { CarListingSearchBoxInputViewModel } from '^/components/CarSearchBox/base/desktop/viewmodel/CarListingSearchBox.InputViewmodel';
import {
  BaseSearchBoxStepManager,
  SearchBoxSteps,
} from '^/components/CarSearchBox/base/desktop/viewmodel/SearchBoxStepManager';
import { typeRouter } from '^/typeRoute/typeRoutes';

import { HomeRouteParams } from './Home.RouteParams';

export class HomeSearchBoxStepManager extends BaseSearchBoxStepManager<HomeRouteParams> {
  constructor(
    public routeParams: HomeRouteParams,
    public carListingSearchInputVM: CarListingSearchBoxInputViewModel,
    public goBackFn: (n?: number) => void,
    public pushCount = 0,
  ) {
    super();
    // eslint-disable-next-line mobx/exhaustive-make-observable
    makeObservable(this, {
      getInputViewModel: true,
      getSteps: true,
      pushStepsToRoute: action.bound,
      replaceStepsInRoute: action.bound,
      updateRouteParams: action.bound,
      guardStep: true,
      pushStep: action.bound,
      clearStep: action.bound,
      replaceStep: true,
      currentStep: true,
      routeParams: true,
      carListingSearchInputVM: true,
      pushCount: true,
    });
  }

  getInputViewModel() {
    return this.carListingSearchInputVM;
  }

  getSteps() {
    return this.routeParams.steps || [];
  }

  updateRouteParams(routeParams: HomeRouteParams) {
    this.routeParams = routeParams;
  }

  pushStepsToRoute(newSteps: SearchBoxSteps[]) {
    this.pushCount += 1;
    typeRouter.routes
      .home2({
        ...(this.routeParams || {}),
        steps: newSteps || undefined,
      })
      .push();
  }

  replaceStepsInRoute(newSteps: SearchBoxSteps[]) {
    try {
      typeRouter.routes
        .home2({
          ...(this.routeParams || {}),
          steps: newSteps || [],
        })
        .replace();
    } catch (e) {
      // debugger;
    }
    // }
  }

  clearStep() {
    for (let i = 0; i < this.pushCount; i += 1) {
      this.goBackFn(1);
    }
  }

  updatePushCountBy(n: number): void {
    this.pushCount += n;
  }
}
